import qs from 'qs';

export const URL_HASHES = {
    openBiddingModal: 'bidding',
    saveInWishlist: 'wishlist=1',
    openBinModal: 'bin=1',
    openChangeCombinedShippingModal: 'open_change_combined_shipping=',
    markAsPaid: 'mark_as_paid='
};

/**
 * Remove hash and forceRedirect param from url
 */
export const removeHashFromUrl = () => {
    const { forceRedirect, ...otherQueryParams } = qs.parse(location.search, {
        ignoreQueryPrefix: true
    });
    history.replaceState(
        {},
        window.title,
        location.pathname +
            qs.stringify(otherQueryParams, { addQueryPrefix: true })
    );
};

export const shouldOpenBiddingModal = () => {
    if (document.location.hash.includes(URL_HASHES.openBiddingModal)) {
        const { bidding } = qs.parse(document.location.hash.substr(1));
        return bidding ? parseInt(bidding, 10) : 0;
    } else {
        return 0;
    }
};

export const shouldSaveInWishlist = () =>
    document.location.hash.includes(URL_HASHES.saveInWishlist);

export const shouldOpenBinModal = () =>
    document.location.hash.includes(URL_HASHES.openBinModal);

export const shouldOpenChangeCombinedShippingModal = () =>
    document.location.hash.includes(URL_HASHES.openChangeCombinedShippingModal);

export const shouldMarkAsPaid = () =>
    document.location.hash.includes(URL_HASHES.markAsPaid);

const getBaseRedirectUrl = () => {
    // Add random query parameter to force reload when redirecting to this url
    // and only the hash differs
    const queryParams = {
        ...qs.parse(location.search, { ignoreQueryPrefix: true }),
        forceRedirect: Math.round(Math.random() * 100000)
    };
    return (
        location.protocol +
        '//' +
        location.host +
        location.pathname +
        qs.stringify(queryParams, { addQueryPrefix: true })
    );
};

export const getBiddingRedirectUrl = amount => {
    const url = getBaseRedirectUrl() + '#' + URL_HASHES.openBiddingModal;
    if (!amount) return url;
    return `${url}=${amount}`;
};

export const getWishlistRedirectUrl = () =>
    getBaseRedirectUrl() + '#' + URL_HASHES.saveInWishlist;

export const getBinRedirectUrl = () =>
    getBaseRedirectUrl() + '#' + URL_HASHES.openBinModal;
